import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import 'react-toastify/dist/ReactToastify.css';

const Title = styled.div`
  ${(props) => props.theme.type.base};
  color: white; // todo
  font-weight: 500;
  flex: 1;
  margin-top: 0;
  display: flex;
  flex-direction: row;
  align-items: center;

  .icon {
    margin-left: ${(props) => props.theme.whitespace.small};
    color: ${(props) => props.theme.colours.positive};
  }
`;
const Subtitle = styled.div`
  ${(props) => props.theme.type.base};
  font-size: 12px;
  color: white; // todo
  margin: ${(props) => props.theme.whitespace.xs} 0;
  margin-bottom: 0;
`;

const Toast = ({ primary, secondary, icon }) => (
  <div>
    <Title showIcon className="title">
      {primary}
      {icon}
    </Title>
    <Subtitle className="subtitle">{secondary}</Subtitle>
  </div>
);
Toast.propTypes = {
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.string,
  icon: PropTypes.element
};
Toast.defaultProps = {
  secondary: '',
  icon: null
};

export default Toast;
